






















































import { Vue, Component, Prop } from "vue-property-decorator";
import { BButton, BDropdown, BDropdownDivider, BDropdownItem, VBTooltip } from "bootstrap-vue";
import { ITableFilter } from "@lib";
import AltAutoButton from "@/core/components/alt-auto-button";
import AltIcon from "@/core/components/alt-icon";

@Component({
    name: "goods-toolbar",
    components: {
        BButton,
        BDropdown,
        BDropdownDivider,
        BDropdownItem,
        AltAutoButton,
        AltIcon,
    },
    directives: { "b-tooltip": VBTooltip },
})
export default class GoodsToolbar extends Vue {
    @Prop({ type: Array, default: () => [] })
    private filter!: ITableFilter[];

    @Prop({ type: Boolean, default: false })
    private canCreate!: boolean;

    private get hasFilter(): boolean {
        return this.filter.length > 0 && !!this.filter.find(f => f.field !== "store");
    }

    private async showModalCreate(): Promise<void> {
        this.$emit("show-create");
    }

    private async showModalFilter(): Promise<void> {
        this.$emit("show-filter");
    }

    private async showModalImport(): Promise<void> {
        this.$emit("show-import");
    }

    private async showModalExport(): Promise<void> {
        this.$emit("show-export");
    }
}
